import PortalLayout from "src/layout/PortalLayout";
import Loadable from "src/components/Loadable";
import { lazy } from "react";



const ValueDashboard = Loadable(
  lazy(() => import("src/app/panel/ADMIN_PORTAL/ValueDashboard"))
);

const EnhancedDashboard = Loadable(
  lazy(() => import("src/app/panel/ADMIN_PORTAL/ValueDashboard/EnhancedDashboard"))
);

const UsersList = Loadable(
  lazy(() => import("src/app/panel/ADMIN_PORTAL/Users/UsersList"))
);
const InternationalList = Loadable(
  lazy(() => import("src/app/panel/ADMIN_PORTAL/Invoices/InternationalList"))
);
const DomesticList = Loadable(
  lazy(() => import("src/app/panel/ADMIN_PORTAL/Invoices/DomesticList"))
);
const List = Loadable(
  lazy(() => import("src/app/panel/ADMIN_PORTAL/TransportStatus/List"))
);

const AdminRoutes = () => {
  // Function to conditionally include "sub-admins" section based on user role
  function useSubAdminRoutes() {
    return null; // Return null if user is not a sub-admin
  }
  // Call the function to get the sub-admin routes
  const subAdminRoutes = useSubAdminRoutes();
  return {
    path: "portal/admin",
    element: <PortalLayout />,
    children: [
      {
        path: "dashboard",
        element: <EnhancedDashboard />,
      },
      {
        path: "value-dashboard",
        element: <ValueDashboard />,
      },
      {
        path: "enhanced-dashboard",
        element: <EnhancedDashboard />,
      },
      {
        path: "users",
        children: [{ path: "", element: <UsersList /> }],
      },
      {
        path: "transport-statuses",
        children: [{ path: "", element: <List /> }],
      },
      {
        path: "invoices",
        children: [
          { path: "domestic", element: <DomesticList /> },
          { path: "international", element: <InternationalList /> },
        ],
      },
      // Include the sub-admin routes if available
      subAdminRoutes,
    ].filter(Boolean),
  };
};

export default AdminRoutes;
